/*
 * fontawesome.js -- Contains initialization for fontawesome API
 */

import {
  register,
  InjectCSS,
  ReplaceElements,
  MutationObserver,
} from '@fortawesome/fontawesome-svg-core/plugins';

import {
  // Imports for Main Library Template
  faBars,
  faBuildingColumns,
  faCaretDown,
  faCaretRight,
  faCommentsQuestion,
  faDiagramNested,
  faDollarSign,
  faEllipsis,
  faEnvelope,
  faLocationDot,
  faMagnifyingGlass,
  faMessageDots,
  faPaperPlane,
  faPaste,
  faPhone,
  faPhoneSquare,
  faRss,
  faSignsPost,
  faUniversalAccess,
  faUserClock,
  faUsers,
  faXmark,

  // Bento Box CONTENT Icons
  faArchive,
  faBook,
  faCloudMusic,
  faCode,
  faCompactDisc,
  faCube,
  faDatabase,
  faFile,
  faFilm,
  faGameBoard,
  faGamepad,
  faImages,
  faLink,
  faListMusic,
  faNewspaper,
  faTabletAndroidAlt,
  faVideo,

  // Other Bento Box Icons
  faArrowUpRightFromSquare,
  faArrowUpToArc,
  faCheck,
  faExclamationTriangle,
  faGraduationCap,
  faNotesMedical,
  faScrewdriverWrench,
  faSearch,
  faTimes,
  faThumbsUp,
} from '@awesome.me/kit-261a22fc18/icons/classic/solid';

import {
  faCircleNotch,
} from '@awesome.me/kit-261a22fc18/icons/sharp-duotone/solid';

import {
  // Imports for Main Library Template
  faCalendarClock,
  faCircleExclamation,
  faClock,
  faDiagramNested as faDiagramNestedD,
  faMagnifyingGlass as faMagnifyingGlassD,
  faMagnifyingGlassPlus,
  faUniversity,
  faUserLock,
  faUsers as faUsersD,
} from '@awesome.me/kit-261a22fc18/icons/duotone/solid';

import {
  // Imports for Main Library Template
  faFacebookF,
  faGithubAlt,
  faInstagram,
  faXTwitter,
  faYoutube,
} from '@awesome.me/kit-261a22fc18/icons/classic/brands';

import {
  // Imports for Main Library Template
  faUntEagle,
  faPthMark,
  faOkMark,
} from '@awesome.me/kit-261a22fc18/icons/kit/custom';


const api = register([InjectCSS, ReplaceElements, MutationObserver]);
api.config.showMissingIcons = true;

api.library.add(
  faArchive,
  faArrowUpRightFromSquare,
  faArrowUpToArc,
  faBars,
  faBook,
  faBuildingColumns,
  faCalendarClock,
  faCaretDown,
  faCaretRight,
  faCheck,
  faCircleExclamation,
  faCircleNotch,
  faClock,
  faCloudMusic,
  faCode,
  faCommentsQuestion,
  faCompactDisc,
  faCube,
  faDatabase,
  faDiagramNested,
  faDiagramNestedD,
  faDollarSign,
  faEllipsis,
  faEnvelope,
  faExclamationTriangle,
  faFacebookF,
  faFile,
  faFilm,
  faGameBoard,
  faGamepad,
  faGithubAlt,
  faGraduationCap,
  faImages,
  faInstagram,
  faLink,
  faListMusic,
  faLocationDot,
  faMagnifyingGlass,
  faMagnifyingGlassD,
  faMagnifyingGlassPlus,
  faMessageDots,
  faNewspaper,
  faNotesMedical,
  faOkMark,
  faPaperPlane,
  faPaste,
  faPhone,
  faPhoneSquare,
  faPthMark,
  faRss,
  faScrewdriverWrench,
  faSearch,
  faSignsPost,
  faTabletAndroidAlt,
  faThumbsUp,
  faTimes,
  faVideo,
  faUniversalAccess,
  faUniversity,
  faUntEagle,
  faUserClock,
  faUserLock,
  faUsers,
  faUsersD,
  faXmark,
  faXTwitter,
  faYoutube,
)

export { api };
